module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/5HBB5W/tc-custom/9781613732649.jpg?1740287409904",
      "alt": "This image is the cover for the book Case Without a Corpse, Sergeant Beef Series"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Case Without a Corpse, Sergeant Beef Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("This is one of Sgt. Beef's most interesting and perplexing cases. It involves a murder, but one in which no body can be found. Young Rogers announces to Beef and others assembled in a local pub that he has committed a murder—then takes his own life. But where is the victim? How did it happen? \"I always supposed,\" says Beef. \"a murder case started with a corpse, and then you had to find out 'oo done it. This time we know 'oo's done it, but we can't find the corpse.\"")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Leo Bruce\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Leo Bruce was the pen name of Rupert Croft-Cooke, who wrote more than twenty highly-praised mysteries featuring Carlous Deene. He also wrote eight mysteries featuring Sgt. William Beef, a cockney police detective who invariably \"knows who done it.\" Croft-Cooke died in 1980.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Chicago Review Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0